import { render } from "./OrderHistoryCard.vue?vue&type=template&id=aa2dde7c"
import script from "./OrderHistoryCard.vue?vue&type=script&lang=js"
export * from "./OrderHistoryCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__